import { render, staticRenderFns } from "./AttendanceMyStaff.vue?vue&type=template&id=4ddfc704"
import script from "./AttendanceMyStaff.vue?vue&type=script&lang=js"
export * from "./AttendanceMyStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports